import {GTM_ATTRIBUTE_PRODUCT_AVAILABILITY} from './gtmSelectors';

export const getGtmCollections = (collectionsString) => {
    return (collectionsString?.length ?? 0) > 0 ? collectionsString.split(',') : [];
};

export const getGtmTags = (tagsString) => {
    if (!tagsString) {
        return '';
    }

    const tagsArray = tagsString.split(',');
    const tags = tagsArray.reduce((result, tag) => {
        if (tag.includes('show_')) {
            result.push(tag.replace(/show_/g, ''));
        } else if (tag === 'tag_news') {
            result.push(tag);
        }

        return result;
    }, []);

    return tags;
};

export const getGtmAvailability = (selectors) => {
    const availability = [];

    selectors.forEach((element) => {
        availability.push(element.getAttribute(GTM_ATTRIBUTE_PRODUCT_AVAILABILITY));
    });

    return availability.join(', ');
};
